import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/authentication/Login'
import Projects from '@/views/projects/Index'
import ProjectsDetails from '@/views/projects/ProjectsDetails'
import BuildingComponentDetails from '@/views/buildingComponents/BuildingComponentsDetails'
import BlueprintsDetails from '@/views/blueprints/BlueprintsDetails'
import EditBlueprintsDetails from '@/views/blueprints/edit/BlueprintsDetails'
import Settings from '@/views/settings/Index'
import Users from '@/views/users/Index'
import BadRequest from '@/views/error/BadRequest'
import MarkerDetails from '@/views/markers/Details'
import EditMarkerDetails from '@/views/markers/edit/Details'
import Solutions from '@/views/solutions/Index'
import SolutionsDetails from '@/views/solutions/SolutionDetail'
import ProductDetails from '@/views/solutions/ProductDetail'
import QR from '@/views/qr/Index'
import Profile from '@/views/users/Profile'
import Error from '@/views/error/Error'
import Todo from '@/views/todo/Index'
import InstallersTodos from '@/views/todo/InstallersTodos'
import Reports from '@/views/reports/Index'
import OldReports from '@/views/reports/oldReports'
import { store } from '../store/store'
import BackButton from '@/components/BackButton'
import Help from '@/views/help/Index'
import MarkerXSolutionDetails from '@/views/markers/markerXSolutions/Details'
import Breadcrumb from '@/components/Breadcrumb'
import ArchivedProjects from '@/views/projects/archived/ArchivedProjects'
import ArchivedProjectDetails from '@/views/projects/archived/ProjectsDetails'
import ArchivedBuildingComponentDetails from '@/views/buildingComponents/archived/BuildingComponentsDetails'
import ArchivedBlueprintsDetails from '@/views/blueprints/archived/BlueprintsDetails'
import ArchivedMarkerDetails from '@/views/markers/archived/Details'
import ArchivedMarkerXSolutionDetails from '@/views/markers/markerXSolutions/archived/Details'
// import Register from '@/views/authentication/register'
import PasswordReset from '@/views/authentication/PasswordReset'
import Terms from '@/views/terms/Index'
import jwtdecode from "jwt-decode"
Vue.use(Router)


const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Projects',
      components: {
        default: Projects,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Archived/Projects',
      name: 'ArchivedProjects',
      components: {
        default: ArchivedProjects,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: {
        guest: true
      }
    },
    {
      path: '/Projects/:id',
      name: 'ProjectDetails',
      components: {
        default: ProjectsDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Archived/Projects/:id',
      name: 'ArchivedProjectDetails',
      components: {
        default: ArchivedProjectDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/BuildingComponents/:id',
      name: 'BuildingComponentDetails',
      components: {
        default: BuildingComponentDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: BuildingComponentDetails,
      meta: {
        guest: false
      }
    },
    {
      path: '/Archived/BuildingComponents/:id',
      name: 'ArchivedBuildingComponentDetails',
      components: {
        default: ArchivedBuildingComponentDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: BuildingComponentDetails,
      meta: {
        guest: false
      }
    },
    {
      path: '/Blueprints/:id',
      name: 'BlueprintsDetails',
      components: {
        default: BlueprintsDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: BlueprintsDetails,
      meta: {
        guest: false
      }
    },
    {
      path: '/Blueprints/Edit/:id',
      name: 'EditBlueprintsDetails',
      components: {
        default: EditBlueprintsDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: BlueprintsDetails,
      meta: {
        guest: false
      }
    },
    {
      path: '/Archived/Blueprints/:id',
      name: 'ArchivedBlueprintsDetails',
      components: {
        default: ArchivedBlueprintsDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: BlueprintsDetails,
      meta: {
        guest: false
      }
    },
    {
      path: '/Markers/Edit/:id',
      name: 'EditMarkerDetails',
      components: {
        default: EditMarkerDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: MarkerDetails,
      meta: {
        guest: false,
      }
    },
    {
      path: '/Markers/:id',
      name: 'MarkerDetails',
      components: {
        default: MarkerDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: MarkerDetails,
      meta: {
        guest: false,
      }
    },
    {
      path: '/Archived/Markers/:id',
      name: 'ArchivedMarkerDetails',
      components: {
        default: ArchivedMarkerDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      // component: MarkerDetails,
      meta: {
        guest: false,
      }
    },
    {
      path: '/Markers/:id/Solution/:markerXSolutionId',
      name: 'MarkerXSolutionDetails',
      components: {
        default: MarkerXSolutionDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false,
      }
    },
    {
      path: '/Archived/Markers/:id/Solution/:markerXSolutionId',
      name: 'ArchivedMarkerXSolutionDetails',
      components: {
        default: ArchivedMarkerXSolutionDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false,
      }
    },
    {
      path: '/Settings',
      name: 'Settings',
      components: {
        default: Settings,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Users',
      name: 'Users',
      components: {
        default: Users,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Error',
      name: 'BadRequest',
      components: {
        default: BadRequest,
        header: BackButton,
      },
      meta: {
        guest: true
      }
    },
    {
      path: '/Solutions',
      name: 'Solutions',
      components: {
        default: Solutions,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Solutions/:id',
      name: 'SolutionDetails',
      components: {
        default: SolutionsDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Solutions/:solutionId/product/:id',
      name: 'ProductDetails',
      components: {
        default: ProductDetails,
        header: BackButton,
        breadcrumb: Breadcrumb
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/QR/:id',
      name: 'QR',
      components: {
        default: QR,
        header: BackButton,
      },
      meta: {
        guest: true
      }
    },
    {
      path: '/Error',
      name: 'Error',
      component: Error,
      meta: {
        guest: false
      }
    },
    {
      path: '/Profile',
      name: 'Profile',
      components: {
        default: Profile,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Todo',
      name: 'Todo',
      components: {
        default: Todo,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Todos/installers',
      name: 'InstallersTodos',
      components: {
        default: InstallersTodos,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Reports',
      name: 'Reports',
      components: {
        default: Reports,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Reports/old',
      name: 'Reports',
      components: {
        default: OldReports,
        header: BackButton,
      },
      meta: {
        guest: false
      }
    },
    {
      path: '/Help',
      name: 'Help',
      components: {
        default: Help,
        header: BackButton,
      },
      meta: {
        guest: false,
      }
    },
    {
      path: '/Terms',
      name: 'Terms',
      component: Terms,
      meta: {
        guest: false
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guest)) {
    next();
  } else {
    if (localStorage.getItem('auth') === null) {
      if (to.name === "Error") {
        next()
      }
      else if (to.path === "/password-reset") {
        next();
      }
      else {
        next({ name: 'Login' })
      }
    }
    else {
      next();
    }
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js